import { render, staticRenderFns } from "./showTMDialogue.vue?vue&type=template&id=3fad00f0&scoped=true"
import script from "./showTMDialogue.vue?vue&type=script&lang=js"
export * from "./showTMDialogue.vue?vue&type=script&lang=js"
import style0 from "./showTMDialogue.vue?vue&type=style&index=0&id=3fad00f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad00f0",
  null
  
)

export default component.exports